export default function SvgInfos() {
  return (
    <>
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="20px" 
        fill="none" 
        viewBox="0 0 24 24">
        <path
          fill="#000"
          d="M12 16.75a.76.76 0 01-.75-.75v-5a.75.75 0 111.5 0v5a.76.76 0 01-.75.75zM12 9.25a.76.76 0 01-.75-.75V8a.75.75 0 111.5 0v.5a.76.76 0 01-.75.75z"
        ></path>
        <path
          fill="#000"
          d="M12 21a9 9 0 110-18 9 9 0 010 18zm0-16.5a7.5 7.5 0 100 15 7.5 7.5 0 000-15z"
        ></path>
      </svg>
    </>
  );
}
